import React from 'react';
import withIcon from '../utilities/withIcon';

const IconList = () => {
  return (
    <g>
      <path d="m.7891 2.4619h14.4218a.75.75 0 0 0 0-1.5h-14.4218a.75.75 0 0 0 0 1.5z" />
      <path d="m15.2109 5.1543h-14.4218a.75.75 0 0 0 0 1.5h14.4218a.75.75 0 0 0 0-1.5z" />
      <path d="m15.2109 9.3457h-14.4218a.75.75 0 1 0 0 1.5h14.4218a.75.75 0 0 0 0-1.5z" />
      <path d="m15.2109 13.5381h-14.4218a.75.75 0 0 0 0 1.5h14.4218a.75.75 0 0 0 0-1.5z" />
    </g>
  );
};

export default withIcon(IconList);
